import React, { useState } from 'react';
import {
  IconButton,
  TableRow,
  TableCell,
  TableBody,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popper,
  Fade,
  Paper
} from '@mui/material';
import AddTaskIcon from '@mui/icons-material/AddTask';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { useLoading } from '../../../../hooks/useLoading';
import { useNotifications } from '../../../../hooks/useNotifications';
import { useDataLayerValue } from '../../../../contextAPI/DataLayer';
import { Form } from '../../../../components/Form';
import { rightsFields } from '../../../../constants/RightsFields';
export const TimesheetMasterTableBody = ({
  currHeaders,
  data,
  toggleUpdate,
  url,
  fields,
  options
}) => {
  // console.log("in master table body", data);

  const [openEdit, setOpenEdit] = useState(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [openRights, setOpenRights] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [id, setId] = useState('');
  const { request } = useLoading();
  const { showNotifications } = useNotifications();
  const [{ _id, fname, lname, email }] = useDataLayerValue();
  const handleOpen = (event, currId) => {
    setAnchorEl(event.currentTarget);
    setId(currId);
    setOpenOptions((prevOpenOptions) => !prevOpenOptions);
  };

  const handleDelete = async () => {
    try {
      const res = await request(() =>
        axios.post(
          url + `/delete/${id}`,
          {
            addedByID: _id,
            addedByName: `${fname} ${lname}`,
            addedByEmail: email
          },
          {
            headers: {
              employeeid: _id
            }
          }
        )
      );
      if (res.data.statusCode !== 200) {
        showNotifications(
          'error',
          'Unable to delete item due to some error',
          5000
        );
      } else {
        showNotifications('success', 'Item successfully deleted', 5000);
        setOpenOptions(false);
        toggleUpdate();
      }
    } catch (error) {
      showNotifications(
        'error',
        'Unable to delete item due to some error',
        5000
      );
      console.log(error);
    }
  };

  const handleEditOpen = async () => {
    const res = await request(() =>
      axios.get(url + `/status/${id}`, {
        headers: {
          employeeid: _id
        }
      })
    );
    if (res.data.statusCode !== 200) {
      showNotifications('error', 'Unable to Edit Item', 5000);
    } else {
      fields.map((field) => {
        if (field.name in res.data.body) {
          field.value = res.data.body[field.name];
        }
        return field;
      });
      setOpenEdit(true);
    }
  };

  const handleEditClose = () => {
    setOpenEdit(false);
    setOpenOptions(false);
    toggleUpdate();
  };

  const handleGiveRightsOpen = () => {
    setOpenRights(true);
  };

  const handleApprove = async () => {
    try {
      const res = await request(() =>
        axios.patch(
          url + `/${id}/approve`,
          {},
          {
            headers: {
              employeeid: _id
            }
          }
        )
      );
      console.log(res.data);
      if (res.data.statusCode !== 200) {
        showNotifications('error', res.data.message, 5000);
      } else {
        showNotifications('success', 'Timesheet successfully Approved', 5000);
        setOpenOptions(false);
        toggleUpdate();
      }
    } catch (error) {
      console.log('HERE');
      showNotifications(
        'error',
        'Unable to delete item due to some error',
        5000
      );
      console.log(error);
    }
  };

  const handleDecline = async () => {
    try {
      const res = await request(() =>
        axios.patch(
          url + `/${id}/reject`,
          {},
          {
            headers: {
              employeeid: _id
            }
          }
        )
      );
      console.log(res.data);
      if (res.data.statusCode !== 200) {
        showNotifications('error', res.data.message, 5000);
      } else {
        showNotifications('success', 'Timesheet successfully Declined', 5000);
        setOpenOptions(false);
        toggleUpdate();
      }
    } catch (error) {
      console.log('HERE');
      showNotifications('error', error, 5000);
      console.log(error);
    }
  };

  const handleGiveRightsClose = () => {
    setOpenRights(false);
    setOpenOptions(false);
    toggleUpdate();
  };

  return (
    <>
      <TableBody>
        {data.body.map((row) => {
          return (
            <TableRow
              key={row._id}
              sx={{
                '&:last-child td, &:last-child th': {
                  border: 0
                }
              }}
            >
              {currHeaders.map((currHeader) => {
                return (
                  <TableCell key={currHeader.key} align="center">
                    {typeof row[currHeader.key] === 'boolean'
                      ? row[currHeader.key]
                        ? 'Yes'
                        : 'No'
                      : row[currHeader.key]}
                  </TableCell>
                );
              })}
              {row.isApproved === 0 || _id === row.managerId ? (
                <TableCell>
                  <IconButton onClick={(event) => handleOpen(event, row._id)}>
                    <MoreVertIcon />
                  </IconButton>
                  <Popper open={openOptions} anchorEl={anchorEl} transition>
                    {({ TransitionProps }) => (
                      <Fade {...TransitionProps} timeout={3500}>
                        <Paper>
                          <List>
                            {'editOption' in options && options.editOption ? (
                              <ListItem disablePadding>
                                <ListItemButton onClick={handleEditOpen}>
                                  <ListItemIcon>
                                    <EditIcon />
                                  </ListItemIcon>
                                  <ListItemText primary="Edit" />
                                </ListItemButton>
                              </ListItem>
                            ) : null}
                            {'deleteOption' in options &&
                            options.deleteOption ? (
                              <ListItem disablePadding>
                                <ListItemButton onClick={handleDelete}>
                                  <ListItemIcon>
                                    <DeleteIcon />
                                  </ListItemIcon>
                                  <ListItemText primary="Delete" />
                                </ListItemButton>
                              </ListItem>
                            ) : null}
                            {'rightsOption' in options &&
                            options.rightsOption ? (
                              <ListItem disablePadding>
                                <ListItemButton onClick={handleGiveRightsOpen}>
                                  <ListItemIcon>
                                    <DeleteIcon />
                                  </ListItemIcon>
                                  <ListItemText primary="Give Rights" />
                                </ListItemButton>
                              </ListItem>
                            ) : null}
                            {'approveOption' in options &&
                            options.approveOption ? (
                              <ListItem disablePadding>
                                <ListItemButton onClick={handleApprove}>
                                  <ListItemIcon>
                                    <AddTaskIcon />
                                  </ListItemIcon>
                                  <ListItemText primary="Approve" />
                                </ListItemButton>
                              </ListItem>
                            ) : null}
                            {'declineOption' in options &&
                            options.declineOption ? (
                              <ListItem disablePadding>
                                <ListItemButton onClick={handleDecline}>
                                  <ListItemIcon>
                                    <DeleteIcon />
                                  </ListItemIcon>
                                  <ListItemText primary="Decline" />
                                </ListItemButton>
                              </ListItem>
                            ) : null}
                          </List>
                        </Paper>
                      </Fade>
                    )}
                  </Popper>
                </TableCell>
              ) : null}
            </TableRow>
          );
        })}
      </TableBody>
      <Form
        title="Edit Details"
        url={url + `/update/${id}`}
        open={openEdit}
        handleClose={handleEditClose}
        fields={fields}
        type="patch"
        headers={{
          employeeid: _id,
          empname: `${fname} ${lname}`,
          empemail: email
        }}
      />
      <Form
        title="Give Rights"
        url={url + `/promote/${id}`}
        open={openRights}
        handleClose={handleGiveRightsClose}
        fields={rightsFields}
        type="patch"
        headers={{
          employeeid: _id,
          empname: `${fname} ${lname}`,
          empemail: email
        }}
      />
    </>
  );
};
